import supabase from "../../../Components/Database/Supabase";
import "./styles-employees.css";
import PersonDetailDialog from "./PersonDetailDialog";
import { getBulkUsers } from "../../../Action/api";

import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Avatar,
  IconButton,
  Paper,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";
import BadgeIcon from "@mui/icons-material/Badge";
import WorkIcon from "@mui/icons-material/Work";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import PeopleIcon from "@mui/icons-material/People";
import SchoolIcon from "@mui/icons-material/School";
import GradeIcon from "@mui/icons-material/Grade";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Tooltip from "@mui/material/Tooltip";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import { Pie, Bar, Doughnut } from "react-chartjs-2";
import "./styles.css";

// Register ChartJS components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
);
// Note: We now directly use department names (depName) from the API instead of mapping from IDs

const People = () => {
  const [people, setPeople] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [departmentPeople, setDepartmentPeople] = useState([]);
  const [showDepartmentTable, setShowDepartmentTable] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoryPeople, setCategoryPeople] = useState([]);
  const [showCategoryTable, setShowCategoryTable] = useState(false);
  const [chartTab, setChartTab] = useState(0);
  const [selectedDepartmentColor, setSelectedDepartmentColor] =
    useState("#228B22"); // State for department color
  const [isLoading, setIsLoading] = useState(true); // Loading state for API calls

  const barChartRef = useRef(null);
  const gradeChartRef = useRef(null);
  const levelChartRef = useRef(null);

  useEffect(() => {
   const fetchPeople = async () => {
      setIsLoading(true);
      try {
        const result = await getBulkUsers();
        if (result && result.length > 0) {
          // Map API data to match our existing structure
          const mappedData = result.map((person) => ({
            id: person.uId,
            staff_id: person.uId,
            uId: person.uId, // Explicitly map uId field for direct access
            name: person.staffFullName,
            role_name:
              person.roleName !== "NONE" ? person.roleName : "Not assigned",
            roleId: person.roleId, // Make sure roleId is directly mapped here
            level_id: person.levelId,
            // levelId: person.levelId, // Make sure levelId is directly mapped here
            level:
              person.levelName !== "NONE" ? person.levelName : "Not assigned",
            grade_id: person.grade,
            grade: person.grade, // Keep the original grade field too
            dep_id: person.depId,
            dep_name:
              person.depName !== "NONE" ? person.depName : "Not assigned",
            res_country:
              person.nationality !== "NONE"
                ? person.nationality
                : "Not specified",
            per_email:
              person.personalEmail !== "NONE"
                ? person.personalEmail
                : person.userId,
            login_id: person.userId,
            profile_image: null,
            no_of_exp: "N/A",
            gender: person.gender,
            dateOfBirth:
              person.dateOfBirth !== "NONE" ? person.dateOfBirth : null,
            contactNumber:
              person.contactNumber !== "NONE" ? person.contactNumber : null,
            currentAddress:
              person.currentAddress !== "NONE" ? person.currentAddress : null,
            permanentAddress:
              person.permanentAddress !== "NONE"
                ? person.permanentAddress
                : null,
            joiningDate:
              person.joiningDate !== "NONE" ? person.joiningDate : null,
            workLocation:
              person.workLocation !== "NONE" ? person.workLocation : null,
            hobbies: person.hobbies !== "{{Hobbies}}" ? person.hobbies : null,
            passion: person.yourPassion !== "NONE" ? person.yourPassion : null,
            // Add these additional fields to ensure they're mapped directly

            desName: person.desName !== "NONE" ? person.desName : null,
            reportingMngId:
              person.reportingMngId !== "NONE" ? person.reportingMngId : null,
            reportingManagerName:
              person.reportingManagerName !== "NONE"
                ? person.reportingManagerName
                : null,
            empTypeId: person.empTypeId !== "NONE" ? person.empTypeId : null,
            empTypeName:
              person.empTypeName !== "NONE" ? person.empTypeName : null,
            probationPeriod:
              person.probationPeriod !== "NONE" ? person.probationPeriod : null,
            shortTermGoal:
              person.shortTermGoal !== "NONE" ? person.shortTermGoal : null,
            longTermGoal:
              person.longTermGoal !== "NONE" ? person.longTermGoal : null,
            governmentId:
              person.governmentId !== "NONE" ? person.governmentId : null,
            bloodGroup: person.bloodGroup !== "NONE" ? person.bloodGroup : null,
            primaryLanguage:
              person.primaryLanguage !== "NONE" ? person.primaryLanguage : null,
            knownLanguage:
              person.knownLanguage !== "NONE" ? person.knownLanguage : null,

                // Add these leave allocation fields
  maritalStatus: person.maritalStatus !== "NONE" ? person.maritalStatus : null,
  
  // Add leave allocation fields
  allocatedAnnualLeave: person.allocatedAnnualLeave || 0,
  allocatedSickLeave: person.allocatedSickLeave || 0,
  allocatedEmergencyLeave: person.allocatedEmergencyLeave || 0,
  allocatedUnpaidLeave: person.allocatedUnpaidLeave || 0,
  allocatedMaternityLeave: person.allocatedMaternityLeave || 0,
  
  // Add used leave fields
  usedAnnualLeave: person.usedAnnualLeave || 0,
  usedSickLeave: person.usedSickLeave || 0,
  usedEmergencyLeave: person.usedEmergencyLeave || 0,
  usedUnpaidLeave: person.usedUnpaidLeave || 0,
  usedMaternityLeave: person.usedMaternityLeave || 0,
            createdAt: person.createdAt !== "NONE" ? person.createdAt : null, // Map createdAt field
          }));

          // Sort the mapped data by uId
          const sortedData = mappedData.sort((a, b) => {
            // Extract numeric part from uId strings (assuming format like "UID001")
            const aNum = a.uId ? parseInt(a.uId.replace(/\D/g, "")) : 0;
            const bNum = b.uId ? parseInt(b.uId.replace(/\D/g, "")) : 0;
            return aNum - bNum; // Sort in ascending order
          });

          setPeople(sortedData);
        } else {
          // Fallback to supabase if API fails
          const { data, error } = await supabase
            .from("003_People_Master")
            .select("*");
          if (!error) {
            // Sort the supabase data by staff_id
            const sortedData = data.sort((a, b) => {
              const aNum = a.staff_id
                ? parseInt(a.staff_id.replace(/\D/g, ""))
                : 0;
              const bNum = b.staff_id
                ? parseInt(b.staff_id.replace(/\D/g, ""))
                : 0;
              return aNum - bNum;
            });
            setPeople(sortedData || []);
          }
        }
      } catch (error) {
        console.error("Error fetching people data:", error);
        // Try supabase as fallback
        const { data, error: supabaseError } = await supabase
          .from("003_People_Master")
          .select("*");
        if (!supabaseError) {
          // Sort the fallback data too
          const sortedData = data.sort((a, b) => {
            const aNum = a.staff_id
              ? parseInt(a.staff_id.replace(/\D/g, ""))
              : 0;
            const bNum = b.staff_id
              ? parseInt(b.staff_id.replace(/\D/g, ""))
              : 0;
            return aNum - bNum;
          });
          setPeople(sortedData || []);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchPeople();
  }, []);

  // Calculate department counts and prepare chart data
  const departmentStats = useMemo(() => {
    const counts = {};
    const nameMap = {};
    const idByName = {};

    people.forEach((person) => {
      // Use department name directly instead of ID mapping
      const deptName = person.dep_name || "Unassigned";
      counts[deptName] = (counts[deptName] || 0) + 1;
      // Store the ID mapping for reference if needed
      if (person.dep_id) {
        idByName[deptName] = person.dep_id;
      }
    });

    // Sort departments by count
    const sortedDepts = Object.keys(counts).sort(
      (a, b) => counts[b] - counts[a]
    );

    // Since we're using actual department names, labels are direct
    const chartLabels = sortedDepts;
    const chartData = sortedDepts.map((dept) => counts[dept]);

    // Generate colors for the chart
    const generateColors = (count) => {
      const baseColors = [
        "rgba(54, 162, 235, 0.8)",
        "rgba(255, 99, 132, 0.8)",
        "rgba(75, 192, 192, 0.8)",
        "rgba(255, 206, 86, 0.8)",
        "rgba(153, 102, 255, 0.8)",
        "rgba(255, 159, 64, 0.8)",
        "rgba(199, 199, 199, 0.8)",
      ];

      const colors = [];
      for (let i = 0; i < count; i++) {
        colors.push(baseColors[i % baseColors.length]);
      }
      return colors;
    };

    const backgroundColors = generateColors(chartLabels.length);

    // Add this new function to get the color for a specific department
    const getDepartmentColor = (deptName) => {
      const index = chartLabels.indexOf(deptName);
      if (index === -1) return "#228B22"; // Default green if not found
      return backgroundColors[index].replace("0.8", "1");
    };

    return {
      counts,
      sortedDepts,
      deptNames: nameMap,
      idByName,
      chartData: {
        labels: chartLabels,
        datasets: [
          {
            data: chartData,
            backgroundColor: backgroundColors,
            borderColor: backgroundColors.map((color) =>
              color.replace("0.8", "1")
            ),
            borderWidth: 1,
          },
        ],
      },
      barChartData: {
        labels: chartLabels,
        datasets: [
          {
            label: "Number of Staff",
            data: chartData,
            backgroundColor: backgroundColors, // Use same colors as pie chart instead of single green color
            borderColor: backgroundColors.map((color) =>
              color.replace("0.8", "1")
            ),
            borderWidth: 1,
          },
        ],
      },
      totalStaff: people.length,
      getDepartmentColor, // Export the new function
    };
  }, [people]);

  // Calculate grade distribution stats using grade_id instead of grade_name
  const gradeStats = useMemo(() => {
    const counts = {};
    const allGrades = [
      "G1",
      "G2",
      "G3",
      "G4",
      "G5",
      "G6",
      "G7",
      "G8",
      "G9",
      "G10",
      "Unassigned",
    ];

    // Initialize all grades with count 0
    allGrades.forEach((grade) => {
      counts[grade] = 0;
    });

    // Count actual staff per grade
    people.forEach((person) => {
      const grade = person.grade_id || "Unassigned";
      counts[grade] = (counts[grade] || 0) + 1;
    });

    // Sort grades in order G1 through G10 plus Unassigned at the end
    const sortedGrades = allGrades.filter(
      (grade) => counts[grade] > 0 || allGrades.includes(grade)
    );

    // Generate gradient colors for the chart - from cold (low grade) to warm (high grade)
    const generateColors = () => {
      // Create a color map with gradient based on grade level
      const colorMap = {
        G1: "rgba(54, 162, 235, 0.8)", // Blue - lowest grade
        G2: "rgba(54, 170, 235, 0.8)",
        G3: "rgba(101, 186, 217, 0.8)",
        G4: "rgba(127, 198, 204, 0.8)",
        G5: "rgba(152, 209, 191, 0.8)", // Middle grades
        G6: "rgba(178, 221, 178, 0.8)",
        G7: "rgba(203, 233, 165, 0.8)",
        G8: "rgba(229, 245, 150, 0.8)",
        G9: "rgba(255, 217, 102, 0.8)",
        G10: "rgba(255, 140, 0, 0.8)", // Orange - highest grade
        Unassigned: "rgba(199, 199, 199, 0.8)", // Gray for unassigned
      };

      return sortedGrades.map((grade) => colorMap[grade]);
    };

    const backgroundColors = generateColors();
    const chartLabels = sortedGrades;
    const chartData = sortedGrades.map((grade) => counts[grade]);

    // Get total staff who have grades assigned
    const gradedStaffCount = Object.entries(counts)
      .filter(([key]) => key !== "Unassigned")
      .reduce((sum, [_, count]) => sum + count, 0);

    // Helper function to get color for a specific grade
    const getGradeColor = (grade) => {
      if (grade === "Unassigned") return "#777";

      // Extract grade number and convert to integer
      const gradeNum = parseInt(grade.substring(1), 10);

      // Color gradient from blue (low) to orange (high)
      if (gradeNum <= 3) return "#3680e5"; // Lower grades: blue
      if (gradeNum <= 6) return "#3CB371"; // Middle grades: green
      if (gradeNum <= 9) return "#FFA500"; // Upper grades: amber
      return "#FF8C00"; // Highest grade: deep orange
    };

    return {
      counts,
      sortedGrades,
      chartData: {
        labels: chartLabels,
        datasets: [
          {
            data: chartData,
            backgroundColor: backgroundColors,
            borderColor: backgroundColors.map((color) =>
              color.replace("0.8", "1")
            ),
            borderWidth: 1,
          },
        ],
      },
      barChartData: {
        labels: chartLabels,
        datasets: [
          {
            label: "Number of Staff",
            data: chartData,
            backgroundColor: backgroundColors, // Use the same colors from the doughnut chart
            borderColor: backgroundColors.map((color) =>
              color.replace("0.8", "1")
            ),
            borderWidth: 1,
          },
        ],
      },
      gradedStaffCount,
      getGradeColor,
    };
  }, [people]);

  // Calculate level distribution stats using the levelName from API
  const levelStats = useMemo(() => {
    const counts = {};

    people.forEach((person) => {
      // Use the 'level' field which contains the levelName from the API
      const levelName = person.level || "Unassigned";
      counts[levelName] = (counts[levelName] || 0) + 1;
    });

    // Sort levels by count
    const sortedLevels = Object.keys(counts).sort(
      (a, b) => counts[b] - counts[a]
    );

    // Generate colors for the chart
    const generateColors = (count) => {
      const baseColors = [
        "rgba(75, 192, 192, 0.8)",
        "rgba(153, 102, 255, 0.8)",
        "rgba(255, 159, 64, 0.8)",
        "rgba(255, 99, 132, 0.8)",
        "rgba(54, 162, 235, 0.8)",
        "rgba(255, 206, 86, 0.8)",
        "rgba(199, 199, 199, 0.8)",
      ];

      const colors = [];
      for (let i = 0; i < count; i++) {
        colors.push(baseColors[i % baseColors.length]);
      }
      return colors;
    };

    const chartLabels = sortedLevels;
    const chartData = sortedLevels.map((level) => counts[level]);
    const backgroundColors = generateColors(chartLabels.length);

    // Add a function to get level color
    const getLevelColor = (level) => {
      const index = sortedLevels.indexOf(level);
      if (index === -1) return "#9c27b0"; // Default purple
      return backgroundColors[index].replace("0.8", "1");
    };

    return {
      counts,
      sortedLevels,
      chartData: {
        labels: chartLabels,
        datasets: [
          {
            data: chartData,
            backgroundColor: backgroundColors,
            borderColor: backgroundColors.map((color) =>
              color.replace("0.8", "1")
            ),
            borderWidth: 1,
          },
        ],
      },
      barChartData: {
        labels: chartLabels,
        datasets: [
          {
            label: "Number of Staff",
            data: chartData,
            backgroundColor: backgroundColors, // Use the same colors from the doughnut chart
            borderColor: backgroundColors.map((color) =>
              color.replace("0.8", "1")
            ),
            borderWidth: 1,
          },
        ],
      },
      getLevelColor, // Export the new function
    };
  }, [people]);

  const handleBarClick = (event, elements) => {
    if (elements.length > 0) {
      const { index } = elements[0];
      const departmentName = departmentStats.barChartData.labels[index];

      // Get the color for this department
      const departmentColor =
        departmentStats.getDepartmentColor(departmentName);

      setSelectedDepartment(departmentName);
      setSelectedDepartmentColor(departmentColor); // Add a new state variable for the color

      // Filter people by department name directly
      const deptPeople = people.filter(
        (person) => person.dep_name === departmentName
      );
      setDepartmentPeople(deptPeople);
      setShowDepartmentTable(true);
    }
  };

  const handleGradeBarClick = (event, elements) => {
    if (elements.length > 0) {
      const { index } = elements[0];
      const gradeId = gradeStats.barChartData.labels[index];

      setSelectedCategory(gradeId);
      const filteredPeople = people.filter(
        (person) => person.grade_id === gradeId
      );
      setCategoryPeople(filteredPeople);
      setShowCategoryTable(true);
    }
  };

  const handleLevelBarClick = (event, elements) => {
    if (elements.length > 0) {
      const { index } = elements[0];
      const levelName = levelStats.barChartData.labels[index];

      setSelectedCategory(levelName);
      // Filter by level which contains the levelName from API
      const filteredPeople = people.filter(
        (person) => person.level === levelName
      );
      setCategoryPeople(filteredPeople);
      setShowCategoryTable(true);
    }
  };

  const handleCloseDepartmentTable = () => {
    setShowDepartmentTable(false);
    setSelectedDepartment(null);
    setDepartmentPeople([]);
  };

  const handleCloseCategoryTable = () => {
    setShowCategoryTable(false);
    setSelectedCategory(null);
    setCategoryPeople([]);
  };

  const handleTabChange = (event, newValue) => {
    setChartTab(newValue);
  };

  const filteredPeople = people.filter((person) =>
    person.name?.toLowerCase().includes(search.toLowerCase())
  );

  const handleClose = () => {
    setSelectedPerson(null);
  };

  return (
    <div className="people-container">
      <h1>Staff Directory</h1>

      {/* Chart Tabs */}
      <Paper elevation={1} sx={{ mb: 2, borderRadius: "12px" }}>
        <Tabs
          value={chartTab}
          onChange={handleTabChange}
          variant="fullWidth"
          textColor="primary"
          TabIndicatorProps={{
            style: {
              backgroundColor: "#228B22",
            },
          }}
          sx={{
            "& .MuiTab-root": {
              color: "#777",
              fontWeight: 500,
              "&.Mui-selected": {
                color: "#228B22",
                fontWeight: 700,
              },
            },
          }}
        >
          <Tab label="People Cards" />
          <Tab label="Department Distribution" />
          <Tab label="Grade Distribution" />
          <Tab label="Level Distribution" />
        </Tabs>
      </Paper>

      {/* People Cards Tab */}
      {chartTab === 0 && (
        <div>
          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                my: 4,
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <CircularProgress
                color="success"
                size={40}
                thickness={4}
                sx={{ mb: 2 }}
              />
              <Typography variant="h6" sx={{ color: "text.secondary" }}>
                Loading people data...
              </Typography>
            </Box>
          ) : (
            <>
              {/* Summary Stats */}
              <Grid container spacing={2} sx={{ mb: 4 }}>
                <Grid item xs={6} sm={3}>
                  <Paper
                    elevation={2}
                    sx={{
                      p: 2,
                      textAlign: "center",
                      borderRadius: "12px",
                      backgroundColor: "rgba(34, 139, 34, 0.9)",
                      color: "white",
                    }}
                  >
                    <PeopleIcon sx={{ fontSize: "2.5rem", mb: 1 }} />
                    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                      {people.length}
                    </Typography>
                    <Typography variant="body2">Total Staff</Typography>
                  </Paper>
                </Grid>

                <Grid item xs={6} sm={3}>
                  <Paper
                    elevation={2}
                    sx={{
                      p: 2,
                      textAlign: "center",
                      borderRadius: "12px",
                      backgroundColor: "rgba(54, 162, 235, 0.9)",
                      color: "white",
                    }}
                  >
                    <BusinessIcon sx={{ fontSize: "2.5rem", mb: 1 }} />
                    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                      {
                        new Set(people.map((p) => p.dep_name).filter(Boolean))
                          .size
                      }
                    </Typography>
                    <Typography variant="body2">Departments</Typography>
                  </Paper>
                </Grid>

                <Grid item xs={6} sm={3}>
                  <Paper
                    elevation={2}
                    sx={{
                      p: 2,
                      textAlign: "center",
                      borderRadius: "12px",
                      backgroundColor: "rgba(255, 99, 132, 0.9)",
                      color: "white",
                    }}
                  >
                    <BadgeIcon sx={{ fontSize: "2.5rem", mb: 1 }} />
                    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                      {
                        new Set(people.map((p) => p.grade_id).filter(Boolean))
                          .size
                      }
                    </Typography>
                    <Typography variant="body2">Grade Levels</Typography>
                  </Paper>
                </Grid>

                <Grid item xs={6} sm={3}>
                  <Paper
                    elevation={2}
                    sx={{
                      p: 2,
                      textAlign: "center",
                      borderRadius: "12px",
                      backgroundColor: "rgba(153, 102, 255, 0.9)",
                      color: "white",
                    }}
                  >
                    <SchoolIcon sx={{ fontSize: "2.5rem", mb: 1 }} />
                    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                      {new Set(people.map((p) => p.level).filter(Boolean)).size}
                    </Typography>
                    <Typography variant="body2">Role Levels</Typography>
                  </Paper>
                </Grid>
              </Grid>

              {/* Search Bar */}
              <Box sx={{ mb: 4 }}>
                <input
                  className="people-search"
                  type="text"
                  placeholder="Search by name..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Box>

              {/* People Cards Grid */}
              <div className="people-grid">
                {filteredPeople.map((person) => (
                  <Paper
                    key={person.id || person.staff_id}
                    elevation={2}
                    className="person-card"
                    onClick={() => setSelectedPerson(person)}
                    sx={{
                      cursor: "pointer",
                      borderRadius: "12px",
                      overflow: "hidden",
                    }}
                  >
                    {/* Card header with fixed height */}
                    <div
                      className="card-header"
                      style={{ backgroundColor: "#228B22" }}
                    ></div>

                    {/* Card avatar with fixed position */}
                    <div className="card-avatar">
                      <Avatar
                        sx={{
                          width: 80,
                          height: 80,
                          border: "4px solid white",
                          fontSize: "2rem",
                          backgroundColor: "#228B22",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        }}
                      >
                        {person.name
                          ? person.name.charAt(0).toUpperCase()
                          : "?"}
                      </Avatar>
                    </div>

                    {/* Card content with consistent padding */}
                    <div className="card-content">
                      <Typography className="card-name">
                        {person.name}
                      </Typography>

                      <Typography className="card-id">
                        <BadgeIcon sx={{ fontSize: "0.9rem", mr: 0.5 }} />
                        {person.staff_id}
                        <Tooltip title="Copy UID">
                          <IconButton
                            size="small"
                            className="copy-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigator.clipboard.writeText(person.staff_id);
                            }}
                            sx={{
                              ml: 0.5,
                              p: 0.3,
                              visibility: "hidden",
                              opacity: 0,
                              transition: "visibility 0s, opacity 0.2s linear",
                            }}
                          >
                            <ContentCopyIcon fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </Typography>

                      <Typography className="card-role">
                        <WorkIcon
                          sx={{ fontSize: "1rem", mr: 0.5, color: "#228B22" }}
                        />
                        {person.role_name || "Not assigned"}
                      </Typography>

                      <div className="card-level-grade">
                        <div className="card-level">
                          {person.level || "No Level"}
                        </div>
                        <div className="card-grade">
                          {person.grade_id
                            ? `Grade ${person.grade_id}`
                            : "No Grade"}
                        </div>
                      </div>

                      <div className="card-info-row">
                        <BusinessIcon
                          sx={{ fontSize: "0.9rem", mr: 0.5, color: "#666" }}
                        />
                        <span
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {person.dep_name || "Not assigned"}
                        </span>
                      </div>

                      <div className="card-info-row">
                        <LocationOnIcon
                          sx={{ fontSize: "0.9rem", mr: 0.5, color: "#666" }}
                        />
                        <span>{person.res_country || "Not specified"}</span>
                      </div>

                      {/* Card footer - pushed to bottom */}
                      <div className="card-footer">
                        <span className="contact-label">Contact via:</span>
                        <div className="email-container">
                          <a
                            href={`mailto:${
                              person.per_email || person.login_id
                            }`}
                            className="contact-button"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <EmailIcon
                              sx={{ fontSize: "1rem", mr: 0.5, flexShrink: 0 }}
                            />
                            <span className="email-text">
                              {person.per_email || person.login_id}
                            </span>
                          </a>
                          <Tooltip title="Copy Email">
                            <IconButton
                              size="small"
                              className="copy-button"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigator.clipboard.writeText(
                                  person.per_email || person.login_id
                                );
                              }}
                              sx={{
                                ml: 0.5,
                                p: 0.3,
                                visibility: "hidden",
                                opacity: 0,
                                transition:
                                  "visibility 0s, opacity 0.2s linear",
                              }}
                            >
                              <ContentCopyIcon fontSize="inherit" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  </Paper>
                ))}
              </div>
              {filteredPeople.length === 0 && !isLoading && (
                <Box sx={{ textAlign: "center", mt: 4, mb: 2 }}>
                  <Typography variant="h6" sx={{ color: "text.secondary" }}>
                    No people match your search
                  </Typography>
                </Box>
              )}
            </>
          )}
        </div>
      )}

      {/* Department Distribution Tab */}
      {chartTab === 1 && (
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} md={4}>
            <Paper
              elevation={2}
              sx={{ p: 3, height: "100%", borderRadius: "12px" }}
            >
              <Typography
                variant="h6"
                sx={{ mb: 2, fontWeight: "bold", color: "#228B22" }}
              >
                Department Distribution
              </Typography>
              <div style={{ height: 250 }}>
                <Pie
                  data={departmentStats.chartData}
                  options={{
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        position: "right",
                        labels: {
                          boxWidth: 12,
                          font: {
                            size: 10,
                          },
                          generateLabels: function (chart) {
                            const data = chart.data;
                            if (data.labels.length && data.datasets.length) {
                              return data.labels.map(function (label, i) {
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);

                                return {
                                  text: label,
                                  fillStyle: style.backgroundColor,
                                  strokeStyle: style.borderColor,
                                  lineWidth: style.borderWidth,
                                  hidden:
                                    isNaN(data.datasets[0].data[i]) ||
                                    meta.data[i].hidden,
                                  index: i,
                                };
                              });
                            }
                            return [];
                          },
                        },
                      },
                      tooltip: {
                        callbacks: {
                          label: function (context) {
                            const label = context.label || "";
                            const value = context.raw || 0;
                            const total =
                              context.chart.data.datasets[0].data.reduce(
                                (a, b) => a + b,
                                0
                              );
                            const percentage = Math.round(
                              (value / total) * 100
                            );
                            return `${label}: ${value} (${percentage}%)`;
                          },
                        },
                      },
                    },
                  }}
                />
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} md={8}>
            <Paper
              elevation={2}
              sx={{ p: 3, height: "100%", borderRadius: "12px" }}
            >
              <Typography
                variant="h6"
                sx={{ mb: 2, fontWeight: "bold", color: "#228B22" }}
              >
                Staff by Department (Click bars to view details)
              </Typography>
              <div style={{ height: 250 }}>
                <Bar
                  ref={barChartRef}
                  data={departmentStats.barChartData}
                  options={{
                    maintainAspectRatio: false,
                    onClick: handleBarClick,
                    scales: {
                      y: {
                        beginAtZero: true,
                        ticks: {
                          precision: 0,
                        },
                      },
                      x: {
                        ticks: {
                          font: {
                            size: 10,
                          },
                          maxRotation: 45,
                          minRotation: 45,
                          callback: function (value, index) {
                            return this.getLabelForValue(value);
                          },
                        },
                      },
                    },
                    plugins: {
                      tooltip: {
                        callbacks: {
                          title: function (tooltipItems) {
                            return tooltipItems[0].label;
                          },
                        },
                      },
                    },
                  }}
                />
              </div>
            </Paper>
          </Grid>

          {/* Department Count Boxes */}
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={4} md={2}>
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    textAlign: "center",
                    borderRadius: "12px",
                    backgroundColor: "rgba(34, 139, 34, 0.9)",
                    color: "white",
                  }}
                >
                  <PeopleIcon sx={{ fontSize: "2.5rem", mb: 1 }} />
                  <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                    {departmentStats.totalStaff}
                  </Typography>
                  <Typography variant="body2">Total Staff</Typography>
                </Paper>
              </Grid>

              {/* For the department count boxes */}
              {departmentStats.sortedDepts.slice(0, 9).map((dept, index) => (
                <Grid item xs={6} sm={4} md={2} key={dept}>
                  <Paper
                    elevation={2}
                    sx={{
                      p: 2,
                      textAlign: "center",
                      borderRadius: "12px",
                      border: "1px solid #eee",
                      cursor: "pointer",
                      transition: "transform 0.2s, box-shadow 0.2s",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      },
                    }}
                    onClick={() => {
                      setSelectedDepartment(dept);
                      const deptPeople = people.filter(
                        (person) => person.dep_name === dept
                      );
                      setDepartmentPeople(deptPeople);
                      setShowDepartmentTable(true);
                    }}
                  >
                    <BusinessIcon
                      sx={{ fontSize: "2rem", mb: 1, color: "#228B22" }}
                    />
                    <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                      {departmentStats.counts[dept]}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "0.85rem",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {dept}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      )}

      {/* Grade Distribution Tab (Now using grade_id with color gradient) */}
      {chartTab === 2 && (
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} md={4}>
            <Paper
              elevation={2}
              sx={{ p: 3, height: "100%", borderRadius: "12px" }}
            >
              <Typography
                variant="h6"
                sx={{ mb: 2, fontWeight: "bold", color: "#2185d0" }}
              >
                Grade Distribution
              </Typography>
              <div style={{ height: 250 }}>
                <Doughnut
                  data={gradeStats.chartData}
                  options={{
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        position: "right",
                        labels: {
                          boxWidth: 12,
                          font: {
                            size: 10,
                          },
                        },
                      },
                      tooltip: {
                        callbacks: {
                          label: function (context) {
                            const label = context.label || "";
                            const value = context.raw || 0;
                            const total =
                              context.chart.data.datasets[0].data.reduce(
                                (a, b) => a + b,
                                0
                              );
                            const percentage = Math.round(
                              (value / total) * 100
                            );
                            const displayLabel =
                              label === "Unassigned" ? label : `Grade ${label}`;
                            return `${displayLabel}: ${value} (${percentage}%)`;
                          },
                        },
                      },
                    },
                  }}
                />
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} md={8}>
            <Paper
              elevation={2}
              sx={{ p: 3, height: "100%", borderRadius: "12px" }}
            >
              <Typography
                variant="h6"
                sx={{ mb: 2, fontWeight: "bold", color: "#2185d0" }}
              >
                Staff by Grade (Click bars to view details)
              </Typography>
              <div style={{ height: 250 }}>
                <Bar
                  ref={gradeChartRef}
                  data={gradeStats.barChartData}
                  options={{
                    maintainAspectRatio: false,
                    onClick: handleGradeBarClick,
                    scales: {
                      y: {
                        beginAtZero: true,
                        ticks: {
                          precision: 0,
                        },
                      },
                      x: {
                        ticks: {
                          font: {
                            size: 10,
                          },
                          maxRotation: 45,
                          minRotation: 45,
                          callback: function (value, index) {
                            // Just return the grade ID without the "Grade" prefix
                            const grade = this.getLabelForValue(value);
                            return grade;
                          },
                        },
                      },
                    },
                    plugins: {
                      tooltip: {
                        callbacks: {
                          title: function (tooltipItems) {
                            // Keep the tooltip with "Grade" prefix for better readability on hover
                            const grade = tooltipItems[0].label;
                            return grade === "Unassigned"
                              ? grade
                              : `Grade ${grade}`;
                          },
                        },
                      },
                    },
                  }}
                />
              </div>
            </Paper>
          </Grid>

          {/* Grade Legend */}
          <Grid item xs={12}>
            <Paper
              elevation={1}
              sx={{
                p: 2,
                mb: 2,
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="subtitle2" sx={{ mr: 2 }}>
                Grade Level:
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    backgroundColor: "#3680e5",
                    borderRadius: 1,
                    mr: 1,
                  }}
                ></Box>
                <Typography variant="body2" sx={{ mr: 3 }}>
                  Lower (G1-G3)
                </Typography>

                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    backgroundColor: "#3CB371",
                    borderRadius: 1,
                    mr: 1,
                  }}
                ></Box>
                <Typography variant="body2" sx={{ mr: 3 }}>
                  Middle (G4-G6)
                </Typography>

                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    backgroundColor: "#FFA500",
                    borderRadius: 1,
                    mr: 1,
                  }}
                ></Box>
                <Typography variant="body2" sx={{ mr: 3 }}>
                  Upper (G7-G9)
                </Typography>

                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    backgroundColor: "#FF8C00",
                    borderRadius: 1,
                    mr: 1,
                  }}
                ></Box>
                <Typography variant="body2">Highest (G10)</Typography>
              </Box>
            </Paper>
          </Grid>

          {/* Grade Count Boxes */}
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={4} md={2}>
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    textAlign: "center",
                    borderRadius: "12px",
                    backgroundColor: "rgba(54, 162, 235, 0.9)",
                    color: "white",
                  }}
                >
                  <GradeIcon sx={{ fontSize: "2.5rem", mb: 1 }} />
                  <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                    {gradeStats.gradedStaffCount}
                  </Typography>
                  <Typography variant="body2">Staff with Grades</Typography>
                </Paper>
              </Grid>

              {/* Show all grades G1 through G10 with color coding */}
              {[
                "G1",
                "G2",
                "G3",
                "G4",
                "G5",
                "G6",
                "G7",
                "G8",
                "G9",
                "G10",
              ].map((gradeId) => (
                <Grid item xs={6} sm={4} md={2} key={gradeId}>
                  <Paper
                    elevation={2}
                    sx={{
                      p: 2,
                      textAlign: "center",
                      borderRadius: "12px",
                      border: "1px solid #eee",
                      cursor: "pointer",
                      transition: "transform 0.2s, box-shadow 0.2s",
                      ...(gradeStats.counts[gradeId] > 0
                        ? {
                            borderColor: gradeStats.getGradeColor(gradeId),
                            backgroundColor: `${gradeStats.getGradeColor(
                              gradeId
                            )}15`, // Very light background
                          }
                        : {}),
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      },
                    }}
                    onClick={() => {
                      if (gradeStats.counts[gradeId] > 0) {
                        setSelectedCategory(gradeId);
                        const filteredPeople = people.filter(
                          (person) => person.grade_id === gradeId
                        );
                        setCategoryPeople(filteredPeople);
                        setShowCategoryTable(true);
                      }
                    }}
                  >
                    <GradeIcon
                      sx={{
                        fontSize: "2rem",
                        mb: 1,
                        color: gradeStats.getGradeColor(gradeId),
                      }}
                    />
                    <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                      {gradeStats.counts[gradeId] || 0}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "0.85rem",
                        fontWeight: gradeStats.counts[gradeId] > 0 ? 600 : 400,
                        color:
                          gradeStats.counts[gradeId] > 0
                            ? gradeStats.getGradeColor(gradeId)
                            : "text.secondary",
                      }}
                    >
                      Grade {gradeId}
                    </Typography>
                  </Paper>
                </Grid>
              ))}

              {/* Unassigned Grade Card */}
              <Grid item xs={6} sm={4} md={2}>
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    textAlign: "center",
                    borderRadius: "12px",
                    border: "1px solid #eee",
                    cursor: "pointer",
                    backgroundColor: "rgba(199, 199, 199, 0.1)",
                    transition: "transform 0.2s, box-shadow 0.2s",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    },
                  }}
                  onClick={() => {
                    if (gradeStats.counts["Unassigned"] > 0) {
                      setSelectedCategory("Unassigned");
                      const filteredPeople = people.filter(
                        (person) => !person.grade_id
                      );
                      setCategoryPeople(filteredPeople);
                      setShowCategoryTable(true);
                    }
                  }}
                >
                  <GradeIcon sx={{ fontSize: "2rem", mb: 1, color: "#777" }} />
                  <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                    {gradeStats.counts["Unassigned"] || 0}
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
                    Unassigned
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}

      {/* Level Distribution Tab */}
      {chartTab === 3 && (
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} md={4}>
            <Paper
              elevation={2}
              sx={{ p: 3, height: "100%", borderRadius: "12px" }}
            >
              <Typography
                variant="h6"
                sx={{ mb: 2, fontWeight: "bold", color: "#9c27b0" }}
              >
                Level Distribution
              </Typography>
              <div style={{ height: 250 }}>
                <Doughnut
                  data={levelStats.chartData}
                  options={{
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        position: "right",
                        labels: {
                          boxWidth: 12,
                          font: {
                            size: 10,
                          },
                        },
                      },
                      tooltip: {
                        callbacks: {
                          label: function (context) {
                            const label = context.label || "";
                            const value = context.raw || 0;
                            const total =
                              context.chart.data.datasets[0].data.reduce(
                                (a, b) => a + b,
                                0
                              );
                            const percentage = Math.round(
                              (value / total) * 100
                            );
                            return `${label}: ${value} (${percentage}%)`;
                          },
                        },
                      },
                    },
                  }}
                />
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} md={8}>
            <Paper
              elevation={2}
              sx={{ p: 3, height: "100%", borderRadius: "12px" }}
            >
              <Typography
                variant="h6"
                sx={{ mb: 2, fontWeight: "bold", color: "#9c27b0" }}
              >
                Staff by Level (Click bars to view details)
              </Typography>
              <div style={{ height: 250 }}>
                <Bar
                  ref={levelChartRef}
                  data={levelStats.barChartData}
                  options={{
                    maintainAspectRatio: false,
                    onClick: handleLevelBarClick,
                    scales: {
                      y: {
                        beginAtZero: true,
                        ticks: {
                          precision: 0,
                        },
                      },
                      x: {
                        ticks: {
                          font: {
                            size: 10,
                          },
                          maxRotation: 45,
                          minRotation: 45,
                        },
                      },
                    },
                  }}
                />
              </div>
            </Paper>
          </Grid>

          {/* Level Count Boxes */}
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={4} md={2}>
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    textAlign: "center",
                    borderRadius: "12px",
                    backgroundColor: "rgba(153, 102, 255, 0.9)",
                    color: "white",
                  }}
                >
                  <SchoolIcon sx={{ fontSize: "2.5rem", mb: 1 }} />
                  <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                    {levelStats.sortedLevels.length}
                  </Typography>
                  <Typography variant="body2">Total Levels</Typography>
                </Paper>
              </Grid>

              {/* Level count boxes */}
              {levelStats.sortedLevels.slice(0, 9).map((levelName, index) => (
                <Grid item xs={6} sm={4} md={2} key={levelName}>
                  <Paper
                    elevation={2}
                    sx={{
                      p: 2,
                      textAlign: "center",
                      borderRadius: "12px",
                      border: "1px solid #eee",
                      cursor: "pointer",
                      transition: "transform 0.2s, box-shadow 0.2s",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      },
                    }}
                    onClick={() => {
                      setSelectedCategory(levelName);
                      const filteredPeople = people.filter(
                        (person) => person.level === levelName
                      );
                      setCategoryPeople(filteredPeople);
                      setShowCategoryTable(true);
                    }}
                  >
                    <SchoolIcon
                      sx={{ fontSize: "2rem", mb: 1, color: "#9c27b0" }}
                    />
                    <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                      {levelStats.counts[levelName]}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "0.85rem",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {levelName}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      )}

      {/* Department People Table Dialog */}
      <Dialog
        open={showDepartmentTable}
        onClose={handleCloseDepartmentTable}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: selectedDepartmentColor, // Use the stored color
            color: "#fff",
            padding: "12px 16px",
          }}
        >
          <Grid container alignItems="center" justifyContent="space-between">
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {selectedDepartment} Staff ({departmentPeople.length})
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleCloseDepartmentTable}
              sx={{
                color: "#fff",
                backgroundColor: "rgba(255,255,255,0.1)",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.2)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent dividers sx={{ padding: "16px" }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                  <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Staff ID</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Role</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Level</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Grade</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Country</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Contact</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {departmentPeople.map((person) => (
                  <TableRow
                    key={person.id}
                    onClick={() => setSelectedPerson(person)}
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "rgba(34, 139, 34, 0.05)",
                      },
                    }}
                  >
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Avatar
                          src={person.profile_image}
                          alt={person.name}
                          sx={{ width: 32, height: 32, mr: 1 }}
                        >
                          {person.name
                            ? person.name.charAt(0).toUpperCase()
                            : "?"}
                        </Avatar>
                        {person.name}
                      </Box>
                    </TableCell>
                    <TableCell>{person.staff_id}</TableCell>
                    <TableCell>{person.role_name}</TableCell>
                    <TableCell>{person.level}</TableCell>
                    <TableCell>
                      {person.grade_id
                        ? `Grade ${person.grade_id}`
                        : "Unassigned"}
                    </TableCell>
                    <TableCell>{person.res_country}</TableCell>
                    <TableCell>
                      <a
                        href={`mailto:${person.per_email || person.login_id}`}
                        onClick={(e) => e.stopPropagation()}
                        style={{ color: "#228B22", textDecoration: "none" }}
                      >
                        <EmailIcon fontSize="small" />
                      </a>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {departmentPeople.length === 0 && (
            <Typography
              sx={{ textAlign: "center", p: 3, color: "text.secondary" }}
            >
              No staff found in this department
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "16px" }}>
          <Button
            onClick={handleCloseDepartmentTable}
            variant="outlined"
            sx={{
              color: selectedDepartmentColor, // Use the stored color
              borderColor: selectedDepartmentColor, // Use the stored color
              "&:hover": {
                borderColor: selectedDepartmentColor.replace("1", "0.8"),
                backgroundColor: `${selectedDepartmentColor}15`,
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Category People Table Dialog (for Grade and Level) */}
      <Dialog
        open={showCategoryTable}
        onClose={handleCloseCategoryTable}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor:
              chartTab === 2
                ? selectedCategory && selectedCategory !== "Unassigned"
                  ? gradeStats.getGradeColor(selectedCategory) // Use the exact same color from the grade chart
                  : selectedCategory === "Unassigned"
                  ? "#777"
                  : "#2185d0" // Use gray for unassigned, default blue otherwise
                : levelStats.getLevelColor(selectedCategory), // Use level-specific color here
            color: "#fff",
            padding: "12px 16px",
          }}
        >
          <Grid container alignItems="center" justifyContent="space-between">
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {chartTab === 2
                ? selectedCategory === "Unassigned"
                  ? selectedCategory
                  : `Grade ${selectedCategory}`
                : "Level: " + selectedCategory}
              ({categoryPeople.length} Staff)
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleCloseCategoryTable}
              sx={{
                color: "#fff",
                backgroundColor: "rgba(255,255,255,0.1)",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.2)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent dividers sx={{ padding: "16px" }}>
          <TableContainer>
            <Table>
              {" "}
              <TableHead>
                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                  <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Staff ID</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Role</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Department</TableCell>
                  {chartTab === 2 ? (
                    <TableCell sx={{ fontWeight: "bold" }}>Level</TableCell>
                  ) : (
                    <TableCell sx={{ fontWeight: "bold" }}>Grade</TableCell>
                  )}
                  <TableCell sx={{ fontWeight: "bold" }}>Country</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Contact</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {categoryPeople.map((person) => (
                  <TableRow
                    key={person.id}
                    onClick={() => setSelectedPerson(person)}
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor:
                          chartTab === 2
                            ? "rgba(54, 162, 235, 0.05)"
                            : "rgba(153, 102, 255, 0.05)",
                      },
                    }}
                  >
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Avatar
                          src={person.profile_image}
                          alt={person.name}
                          sx={{ width: 32, height: 32, mr: 1 }}
                        >
                          {person.name
                            ? person.name.charAt(0).toUpperCase()
                            : "?"}
                        </Avatar>
                        {person.name}
                      </Box>
                    </TableCell>
                    <TableCell>{person.staff_id}</TableCell>
                    <TableCell>{person.role_name}</TableCell>
                    <TableCell>{person.dep_name || "Not assigned"}</TableCell>
                    {chartTab === 2 ? (
                      <TableCell>{person.level}</TableCell>
                    ) : (
                      <TableCell>
                        {person.grade_id
                          ? `Grade ${person.grade_id}`
                          : "Unassigned"}
                      </TableCell>
                    )}
                    <TableCell>{person.res_country}</TableCell>
                    <TableCell>
                      <a
                        href={`mailto:${person.per_email || person.login_id}`}
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          color: chartTab === 2 ? "#2185d0" : "#9c27b0",
                          textDecoration: "none",
                        }}
                      >
                        <EmailIcon fontSize="small" />
                      </a>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {categoryPeople.length === 0 && (
            <Typography
              sx={{ textAlign: "center", p: 3, color: "text.secondary" }}
            >
              No staff found in this {chartTab === 2 ? "grade" : "level"}
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "16px" }}>
          <Button
            onClick={handleCloseCategoryTable}
            variant="outlined"
            sx={{
              color:
                chartTab === 2
                  ? selectedCategory && selectedCategory !== "Unassigned"
                    ? gradeStats.getGradeColor(selectedCategory)
                    : selectedCategory === "Unassigned"
                    ? "#777"
                    : "#2185d0"
                  : levelStats.getLevelColor(selectedCategory), // Use level-specific color here
              borderColor:
                chartTab === 2
                  ? selectedCategory && selectedCategory !== "Unassigned"
                    ? gradeStats.getGradeColor(selectedCategory)
                    : selectedCategory === "Unassigned"
                    ? "#777"
                    : "#2185d0"
                  : levelStats.getLevelColor(selectedCategory), // Use level-specific color here
              "&:hover": {
                borderColor:
                  chartTab === 2
                    ? selectedCategory && selectedCategory !== "Unassigned"
                      ? gradeStats.getGradeColor(selectedCategory)
                      : selectedCategory === "Unassigned"
                      ? "#555"
                      : "#1976d2"
                    : levelStats
                        .getLevelColor(selectedCategory)
                        .replace("1", "0.8"), // Adjust hover color
                backgroundColor:
                  chartTab === 2
                    ? `${
                        selectedCategory && selectedCategory !== "Unassigned"
                          ? gradeStats.getGradeColor(selectedCategory)
                          : selectedCategory === "Unassigned"
                          ? "#777"
                          : "#2185d0"
                      }15`
                    : `${levelStats.getLevelColor(selectedCategory)}15`, // Add transparency for hover
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Loading indicator */}
      {isLoading && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            my: 4,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <CircularProgress
            color="success"
            size={40}
            thickness={4}
            sx={{ mb: 2 }}
          />
          <Typography variant="h6" sx={{ color: "text.secondary" }}>
            Loading people data...
          </Typography>
        </Box>
      )}

      {/* Person Detail Dialog */}
      <PersonDetailDialog
        selectedPerson={selectedPerson}
        open={Boolean(selectedPerson)}
        onClose={handleClose}
      />
    </div>
  );
};

export default People;
